import type { TransactionEnvelope } from "@saberhq/solana-contrib";
import type { PublicKey } from "@solana/web3.js";

export interface PendingPositionWrapper {
  positionWrapper: PublicKey;
  wrapMint: PublicKey;
  tx: TransactionEnvelope;
}

export interface PendingMintWrapTokens {
  position: PublicKey;
  nftVault: PublicKey;
  tx: TransactionEnvelope;
}

export interface PendingMintAndStake {
  position: PublicKey;
  nftVault: PublicKey;
  quarryWrapper: PublicKey;
  tx: TransactionEnvelope;
}
